// extracted by mini-css-extract-plugin
export default {"rating":"Lz-z","numberOfStars":"Mz-z","count":"Nz-z","barGraphSpacing":"Oz-z","barGraph":"Pz-z"};